import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
export const ACCESS_TOKEN_EVENT = 'zeedcom:access-token';
const SKEW_MS = 60 * 1000;

let inflight: Promise<string | null> | null = null;

export const readAccessTokenExp = (token: string): number | null => {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const normalized = part.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(normalized));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const isAccessTokenFresh = (token: string | null): boolean => {
  if (!token) return false;
  const exp = readAccessTokenExp(token);
  if (!exp) return false;
  return exp > Date.now() + SKEW_MS;
};

export const refreshAccessToken = (): Promise<string | null> => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) return Promise.resolve(null);
  if (inflight) return inflight;

  inflight = axios
    .post(`${API_BASE_URL}/auth/refresh`, { refreshToken })
    .then((response) => {
      const next = response.data?.data?.accessToken;
      if (!next || typeof next !== 'string') return null;
      localStorage.setItem('accessToken', next);
      window.dispatchEvent(new CustomEvent(ACCESS_TOKEN_EVENT, { detail: next }));
      return next;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });

  return inflight;
};

export const ensureFreshAccessToken = (): Promise<string | null> => {
  const current = localStorage.getItem('accessToken');
  if (isAccessTokenFresh(current)) return Promise.resolve(current);
  return refreshAccessToken();
};

export const onAccessTokenRefreshed = (cb: (token: string) => void): (() => void) => {
  const handler = (event: Event) => {
    const token = (event as CustomEvent<string>).detail;
    if (token) cb(token);
  };
  window.addEventListener(ACCESS_TOKEN_EVENT, handler);
  return () => window.removeEventListener(ACCESS_TOKEN_EVENT, handler);
};
